export default "__VITE_PUBLIC_ASSET__047e3f91__"